function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("circle", {
  opacity: 0.1,
  cx: 18,
  cy: 18.5,
  r: 18,
  fill: "#758596"
}), React.createElement("path", {
  d: "M14 17.5L18 21.5L27 12.5",
  stroke: "#758596",
  strokeWidth: 2,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M27.9376 17.385C28.191 19.6431 27.6678 21.9202 26.4541 23.8412C25.2404 25.7622 23.4087 27.2126 21.2605 27.9535C19.1124 28.6944 16.7761 28.6816 14.6362 27.9173C12.4963 27.1529 10.6806 25.6826 9.48797 23.7484C8.29539 21.8142 7.7971 19.5315 8.07515 17.2763C8.35321 15.0211 9.39104 12.9278 11.0177 11.3413C12.6444 9.75468 14.7629 8.76941 17.0243 8.54771C19.2858 8.32601 21.5553 8.88111 23.4591 10.1216",
  stroke: "#758596",
  strokeWidth: 2,
  strokeLinecap: "round"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 36,
  height: 36,
  fill: "white",
  transform: "translate(0 0.5)"
})));

var SvgVoteIcon = function SvgVoteIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVoteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vote_icon.f26d90cb.svg";
export { ForwardRef as ReactComponent };